module.exports = __webpack_public_path__ + "img/song_des_3.95ae17aa.jpg";